enum HeaderBGEnum {
  Dark = 'Dark',
  Light = 'Light',
  Transparent = 'Transparent',
}

export default HeaderBGEnum;
